/* tslint:disable */
/* eslint-disable */
export enum CreateUserConflictTypes {
  EmailAlreadyInUse = 'email_already_in_use'
}
